import * as React from 'react';
import { GameProvider } from '@0g/react';
import { EntityList } from './EntityList';
import { Panel, PanelSurface, PanelToggle, PanelContent, PanelHeader, } from './components/Panel';
import { EntityDetails } from './EntityDetails';
import { AddEntityButton } from './AddEntityButton';
export function Editor(_a) {
    var game = _a.game;
    return (React.createElement(GameProvider, { value: game },
        React.createElement(PanelSurface, null,
            React.createElement(Panel, { anchor: "left" },
                React.createElement(PanelContent, null,
                    React.createElement(PanelHeader, null,
                        React.createElement(AddEntityButton, null)),
                    React.createElement(EntityList, null)),
                React.createElement(PanelToggle, null)),
            React.createElement(Panel, { anchor: "right" },
                React.createElement(PanelContent, null,
                    React.createElement(EntityDetails, null)),
                React.createElement(PanelToggle, null)))));
}
//# sourceMappingURL=Editor.js.map